const Search = {
  options: {
    data: {
      images: [
        {
          to: '',
          src: '',
        },
      ],
    },
    customization: {},
    widgets: {
      Menu_SeachInputSettings: {
        type: 'Menu',
        order: 100,
        renderOptions: {
          controlKey: 'searchInputSettings',
        },
        options: {
          placeholder: {
            type: 'Text',
            order: 1,
          },
          textSize: {
            data: {
              max: 20,
              min: 0,
              step: 1,
            },
            type: 'RangePx',
            order: 1,
          },
          textColor: {
            type: 'HexColor',
            order: 2,
          },
          borderColor: {
            type: 'HexColor',
            order: 3,
          },
          innerBackgroundColor: {
            type: 'HexColor',
            order: 4,
          },
        },
      },
      Menu_SearchIconSettings: {
        type: 'Menu',
        order: 5,
        renderOptions: {
          controlKey: 'SearchIconSettings',
        },
        options: {
          'widget.ToggleTabs_1': {
            type: 'ToggleTabs',
            order: 5,
            renderOptions: {
              controlKey: 'isSearchIcon',
            },
            options: {
              searchIcon: {
                type: 'IconSelector',
                data: {
                  defaultIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005417301.png',
                },
                order: 1,
              },
              searchIconBackgroundColor: {
                type: 'HexColor',
                order: 6,
              },
              searchIconColor: {
                type: 'HexColor',
                order: 7,
              },
              searchIconWidth: {
                data: {
                  max: 30,
                  min: 10,
                  step: 1,
                },
                type: 'RangePx',
              },
              searchIconBorderRadius: {
                data: {
                  max: 40,
                  min: 0,
                  step: 1,
                  svgType: 'border',
                },
                type: 'FourPx',
              },
            },
          },
        },
      },
      Menu_GeneralSettings: {
        type: 'Menu',
        order: 1300,
        renderOptions: {
          controlKey: 'OtherSettings',
        },
        options: {
          'widget.Tabs_1': {
            type: 'Tabs',
            order: 13,
            options: {
              containerPadding: {
                data: {
                  max: 30,
                  min: 0,
                  step: 1,
                  svgType: 'edge',
                },
                type: 'FourPx',
              },
              padding: {
                data: {
                  max: 30,
                  min: 0,
                  step: 1,
                  svgType: 'edge',
                },
                type: 'FourPx',
              },
              borderRadius: {
                data: {
                  max: 30,
                  min: 0,
                  step: 1,
                  svgType: 'border',
                },
                type: 'FourPx',
              },
            },
          },
          'widget.ToggleRadioTabs_1': {
            type: 'ToggleRadioTabs',
            order: 14,
            renderOptions: {
              controlKey: 'backgroundType',
              direction: 'row',
            },
            options: {
              backgroundImage: {
                type: 'ImageUploader',
              },
              backgroundColor: {
                type: 'HexColor',
              },
            },
          },
          productTitleMarginBottom: {
            type: 'RangePx',
            order: 15,
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
          },
          boxShadow: {
            type: 'ChildComponentRenderer',
            order: 26,
            data: {
              componentNames: ['shadow1', 'shadow2', 'shadow3'],
            },
          },
        },
      },
    },
  },
  variants: [
    {
      id: 'Search_1',
      name: 'Search_1',
      type: 'Search',
      data: {
        images: [
          {
            to: '',
            src: '',
          },
        ],
      },
      customization: {
        padding: '5px 8px 4px 8px',
        textSize: '12px',
        textColor: '#cccccc',
        searchIcon:
          'https://d9aff4nz0lkg0.cloudfront.net/mobligo/3bd48b49-bdf1-426b-897e-0d989a7c27e1/1725533325071.png',
        borderColor: '#F0EEFB',
        placeholder: '\u00dcr\u00fcn aray\u0131n...',
        borderRadius: '8px 8px 8px 8px',
        isSearchIcon: true,
        backgroundType: '-',
        backgroundColor: '#F0EEFB',
        backgroundImage: '',
        searchIconColor: '#030303',
        searchIconWidth: '20px',
        containerPadding: '8px 8px 8px 8px',
        innerBackgroundColor: '#ffffff',
        searchIconBorderRadius: '0px 0px 0px 0px',
        searchIconBackgroundColor: '#ffffff',
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Search_1.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'Search_qr',
      name: 'Search_qr',
      type: 'Search',
      data: {
        images: [
          {
            to: '',
            src: '',
          },
        ],
      },
      customization: {
        padding: '4px 8px 4px 8px',
        textSize: '12px',
        textColor: '#d1d1d1',
        searchIcon:
          'https://d9aff4nz0lkg0.cloudfront.net/mobligo/3bd48b49-bdf1-426b-897e-0d989a7c27e1/1725533334139.png',
        borderColor: '#F0EEFB',
        placeholder: '\u00dcr\u00fcn aray\u0131n...',
        borderRadius: '8px 8px 8px 8px',
        isSearchIcon: true,
        backgroundType: '-',
        backgroundColor: '#F0EEFB',
        backgroundImage: '',
        searchIconColor: '#000000',
        searchIconWidth: '20px',
        containerPadding: '5px 8px 8px 8px',
        innerBackgroundColor: '#ffffff',
        searchIconBorderRadius: '0px 0px 0px 0px',
        searchIconBackgroundColor: '#ffffff',
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Search_qr.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'Search_2',
      name: 'Search_2',
      type: 'Search',
      data: {
        images: [
          {
            to: '',
            src: '',
          },
        ],
      },
      customization: {
        backgroundColor: '#F0EEFB',
        textColor: '#7059ef',
        textSize: '12px',
        backgroundImage: '',
        backgroundType: '-',
        borderColor: '#F0EEFB',
        containerPadding: '8px 8px 8px 8px',
        padding: '8px 8px 8px 8px',
        borderRadius: '8px 8px 8px 8px',
        isSearchIcon: false,
        searchIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005417301.png',
        searchIconBackgroundColor: '#F0EEFB',
        searchIconColor: '#F0EEFB',
        searchIconWidth: '20px',
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Search+2%402x.png',
      minMobileAppVersion: 1,
      isComingSoon: true,
    },
    {
      id: 'Search_3',
      name: 'Search_3',
      type: 'Search',
      data: {
        images: [
          {
            to: '',
            src: '',
          },
        ],
      },
      customization: {
        backgroundColor: '#F0EEFB',
        textColor: '#7059ef',
        textSize: '12px',
        backgroundImage: '',
        backgroundType: '-',
        borderColor: '#F0EEFB',
        containerPadding: '8px 8px 8px 8px',
        padding: '8px 8px 8px 8px',
        borderRadius: '8px 8px 8px 8px',
        isSearchIcon: false,
        searchIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005417301.png',
        searchIconBackgroundColor: '#F0EEFB',
        searchIconColor: '#F0EEFB',
        searchIconWidth: '20px',
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Search+3%402x.png',
      minMobileAppVersion: 1,
      isComingSoon: true,
    },
    {
      id: 'Search_4',
      name: 'Search_4',
      type: 'Search',
      data: {
        images: [
          {
            to: '',
            src: '',
          },
        ],
      },
      customization: {
        backgroundColor: '#F0EEFB',
        textColor: '#7059ef',
        textSize: '12px',
        backgroundImage: '',
        backgroundType: '-',
        borderColor: '#F0EEFB',
        containerPadding: '8px 8px 8px 8px',
        padding: '8px 8px 8px 8px',
        borderRadius: '8px 8px 8px 8px',
        isSearchIcon: false,
        searchIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005417301.png',
        searchIconBackgroundColor: '#F0EEFB',
        searchIconColor: '#F0EEFB',
        searchIconWidth: '20px',
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Search+4%402x.png',
      minMobileAppVersion: 1,
      isComingSoon: true,
    },
    {
      id: 'Search_5',
      name: 'Search_5',
      type: 'Search',
      data: {
        images: [
          {
            to: '',
            src: '',
          },
        ],
      },
      customization: {
        backgroundColor: '#F0EEFB',
        textColor: '#7059ef',
        textSize: '12px',
        backgroundImage: '',
        backgroundType: '-',
        borderColor: '#F0EEFB',
        containerPadding: '8px 8px 8px 8px',
        padding: '8px 8px 8px 8px',
        borderRadius: '8px 8px 8px 8px',
        isSearchIcon: false,
        searchIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005417301.png',
        searchIconBackgroundColor: '#F0EEFB',
        searchIconColor: '#F0EEFB',
        searchIconWidth: '20px',
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Search+5%402x.png',
      minMobileAppVersion: 1,
      isComingSoon: true,
    },
    {
      id: 'Search_6',
      name: 'Search_6',
      type: 'Search',
      data: {
        images: [
          {
            to: '',
            src: '',
          },
        ],
      },
      customization: {
        backgroundColor: '#F0EEFB',
        textColor: '#7059ef',
        textSize: '12px',
        backgroundImage: '',
        backgroundType: '-',
        borderColor: '#F0EEFB',
        containerPadding: '8px 8px 8px 8px',
        padding: '8px 8px 8px 8px',
        borderRadius: '8px 8px 8px 8px',
        isSearchIcon: false,
        searchIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005417301.png',
        searchIconBackgroundColor: '#F0EEFB',
        searchIconColor: '#F0EEFB',
        searchIconWidth: '20px',
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Search+6%402x.png',
      minMobileAppVersion: 1,
      isComingSoon: true,
    },
    {
      id: 'Search_7',
      name: 'Search_7',
      type: 'Search',
      data: {
        images: [
          {
            to: '',
            src: '',
          },
        ],
      },
      customization: {
        backgroundColor: '#F0EEFB',
        textColor: '#7059ef',
        textSize: '12px',
        backgroundImage: '',
        backgroundType: '-',
        borderColor: '#F0EEFB',
        containerPadding: '8px 8px 8px 8px',
        padding: '8px 8px 8px 8px',
        borderRadius: '8px 8px 8px 8px',
        isSearchIcon: false,
        searchIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005417301.png',
        searchIconBackgroundColor: '#F0EEFB',
        searchIconColor: '#F0EEFB',
        searchIconWidth: '20px',
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Search+7%402x.png',
      minMobileAppVersion: 1,
      isComingSoon: true,
    },
    {
      id: 'Search_8',
      name: 'Search_8',
      type: 'Search',
      data: {
        images: [
          {
            to: '',
            src: '',
          },
        ],
      },
      customization: {
        backgroundColor: '#F0EEFB',
        textColor: '#7059ef',
        textSize: '12px',
        backgroundImage: '',
        backgroundType: '-',
        borderColor: '#F0EEFB',
        containerPadding: '8px 8px 8px 8px',
        padding: '8px 8px 8px 8px',
        borderRadius: '8px 8px 8px 8px',
        isSearchIcon: false,
        searchIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005417301.png',
        searchIconBackgroundColor: '#F0EEFB',
        searchIconColor: '#F0EEFB',
        searchIconWidth: '20px',
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Search+8%402x.png',
      minMobileAppVersion: 1,
      isComingSoon: true,
    },
    {
      id: 'Search_9',
      name: 'Search_9',
      type: 'Search',
      data: {
        images: [
          {
            to: '',
            src: '',
          },
        ],
      },
      customization: {
        backgroundColor: '#F0EEFB',
        textColor: '#7059ef',
        textSize: '12px',
        backgroundImage: '',
        backgroundType: '-',
        borderColor: '#F0EEFB',
        containerPadding: '8px 8px 8px 8px',
        padding: '8px 8px 8px 8px',
        borderRadius: '8px 8px 8px 8px',
        isSearchIcon: false,
        searchIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005417301.png',
        searchIconBackgroundColor: '#F0EEFB',
        searchIconColor: '#F0EEFB',
        searchIconWidth: '20px',
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Search+9%402x.png',
      minMobileAppVersion: 1,
      isComingSoon: true,
    },
    {
      id: 'Search_10',
      name: 'Search_10',
      type: 'Search',
      data: {
        images: [
          {
            to: '',
            src: '',
          },
        ],
      },
      customization: {
        backgroundColor: '#F0EEFB',
        textColor: '#7059ef',
        textSize: '12px',
        backgroundImage: '',
        backgroundType: '-',
        borderColor: '#F0EEFB',
        containerPadding: '8px 8px 8px 8px',
        padding: '8px 8px 8px 8px',
        borderRadius: '8px 8px 8px 8px',
        isSearchIcon: false,
        searchIcon: 'https://d9aff4nz0lkg0.cloudfront.net/icons/1706005417301.png',
        searchIconBackgroundColor: '#F0EEFB',
        searchIconColor: '#F0EEFB',
        searchIconWidth: '20px',
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Search+10%402x.png',
      minMobileAppVersion: 1,
      isComingSoon: true,
    },
    {
      id: 'Search_11',
      name: 'Search_11',
      type: 'Search',
      data: {
        images: [
          {
            to: '',
            src: '',
          },
        ],
      },
      customization: {
        textSize: '12px',
        textColor: '#8B7F78',
        searchIcon:
          'https://d9aff4nz0lkg0.cloudfront.net/mobligo/3bd48b49-bdf1-426b-897e-0d989a7c27e1/1725533334139.png',
        placeholder: 'Ürün, kategori veya marka ara.',
        borderRadius: '4px 4px 4px 4px',
        isSearchIcon: true,
        backgroundType: '-',
        backgroundColor: '#F0EEFB',
        backgroundImage: '',
        searchIconColor: '#FFFFFF',
        searchIconWidth: '20px',
        containerPadding: '5px 8px 8px 8px',
        innerBackgroundColor: '#f6f6f6',
        searchIconBorderRadius: '4px 4px 4px 4px',
        searchIconBackgroundColor: '#fe873e',
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Search_11.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
  ],
};

export default Search;
